import { Tooltip } from 'antd';
import { calcTotalEnergy, calcTotalSave, getRecommand } from '@/constants/cost-saving';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT } from 'eco-design/elements/eco-cart/type.d';
import EFPicture from 'elem/compCommon/EFPicture';
import { cloneDeep } from 'lodash';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

export default function F() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [focus, setFocus] = useState('');
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);
    const [opens, setOpens] = useState([]);
    const [openTooltipKey, setOpenTooltipKey] = useState(null);
    const isNA = ['us', 'ca'].includes(locale);

    useEffect(() => {
        if (!openTooltipKey || typeof window === 'undefined') return;

        const closeTooltip = (e?: any) => {
            // 点击的是加号按钮本身时，交给 antd 的受控切换处理，避免出现“先关再开”导致需要点两次
            const target = e?.target;
            if (target && typeof target.closest === 'function' && target.closest('.addSubtractor-add')) {
                return;
            }
            setOpenTooltipKey(null);
        };

        document.addEventListener('mousedown', closeTooltip, true);
        document.addEventListener('touchstart', closeTooltip, true);
        document.addEventListener('pointerdown', closeTooltip, true);
        window.addEventListener('scroll', closeTooltip, true);
        window.addEventListener('wheel', closeTooltip, true);
        window.addEventListener('touchmove', closeTooltip, true);

        return () => {
            document.removeEventListener('mousedown', closeTooltip, true);
            document.removeEventListener('touchstart', closeTooltip, true);
            document.removeEventListener('pointerdown', closeTooltip, true);
            window.removeEventListener('scroll', closeTooltip, true);
            window.removeEventListener('wheel', closeTooltip, true);
            window.removeEventListener('touchmove', closeTooltip, true);
        };
    }, [openTooltipKey]);

    const SolarPanels = [
        {
            img: '/responsive/picture/common-products/400w_rigid.png',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w_rigid',
            title: t('secF_card_400w_rigid'),
            cartTitle: t('secF_cart_400w_rigid_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                    ca: '8006700236954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                    ca: '44244774682778',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '/responsive/picture/common-products/400w.png',
            quantity: 4,
            isActive: true,
            energy: 400,
            id: '400w',
            title: '400W',
            cartTitle: 'EcoFlow 400W Portable Solar Pabel',
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '/responsive/picture/common-products/400w.png',
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '500w',
            title: '500W',
            cartTitle: 'EcoFlow 500W Portable Solar Pabel',
            productId: (() => {
                const localMap: any = {
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
    ];

    const [solarpanels, setSolarpanels] = useState(isNA ? SolarPanels : []);

    let cards: any = [
        {
            img: '',
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secF_card1_power'),
            title: t('secF_card1_title'),
            id: 'dpu',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/smart-home-panel-2?variant=40767883608137',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774682778',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6964802486345',
                    ca: '8006700236954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40767883608137',
                    ca: '44244774682778',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
            children: isNA ? (locale === 'us' ? JSON.parse(JSON.stringify([solarpanels[0]])) : JSON.parse(JSON.stringify([solarpanels[1]]))) : [],
        },
        {
            img: '',
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secF_card2_power'),
            title: t('secF_card2_title'),
            id: 'dp3',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41703627980873',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=52644324901235',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41703627980873',
                    ca: '52644324901235',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
            children: isNA ? JSON.parse(JSON.stringify(locale === 'us' ? [solarpanels[1]] : [solarpanels[1], solarpanels[2]])) : [],
        },
    ];

    if (locale === 'za') {
        cards = [
            {
                img: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719802853526/Group%20161269138.png',
                tag: '',
                power: t('secF_card1_power'),
                title: t('secF_card1_title'),
                id: 'deltapro_powerstream',
                link_more: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station?variant=41819914666193',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                buy_now: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/ecoflow-powerstream-microinverter-recommended?variant=41819914666193',
                    };
                    return localMap[locale] || localMap.za;
                })(),

                productId: (() => {
                    const localMap: any = {
                        za: '7316672807121',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        za: '41819914666193',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secF_card1_desc1'), t('secF_card1_desc2')],
                children: [],
                text: {
                    title: t('secF_card1_text_title'),
                    desc: 'secF_card1_text_desc',
                },
            },
            {
                img: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719802907125/Group%20161269137.png',
                tag: '',
                power: t('secF_card2_power'),
                title: t('secF_card2_title'),
                id: 'delta2max_powerstream',
                link_more: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station?variant=41819914633425',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                buy_now: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/ecoflow-powerstream-microinverter-recommended?variant=41819914633425',
                    };
                    return localMap[locale] || localMap.za;
                })(),
                productId: (() => {
                    const localMap: any = {
                        za: '7316672807121',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        za: '41819914633425',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secF_card2_desc1'), t('secF_card2_desc2')],
                children: [],
                text: {
                    title: t('secF_card2_text_title'),
                    desc: 'secF_card2_text_desc',
                },
            },
            {
                img: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719802978317/Group%20161269138%20(1).png',
                tag: '',
                power: t('secF_card3_power'),
                title: t('secF_card3_title'),
                id: 'delta2_powerstream',
                link_more: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/delta-2-portable-power-station?variant=41819914600657',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                buy_now: (() => {
                    const localMap: any = {
                        za: 'https://za.ecoflow.com/products/ecoflow-powerstream-microinverter-recommended?variant=41819914600657',
                    };
                    return localMap[locale] || localMap.za;
                })(),
                productId: (() => {
                    const localMap: any = {
                        za: '7316672807121',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        za: '41819914600657',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                descArr: [t('secF_card3_desc1'), t('secF_card3_desc2')],
                children: [],
                text: {
                    title: t('secF_card3_text_title'),
                    desc: 'secF_card3_text_desc',
                },
            },
        ];
    }

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        const target = card?.children?.find((item: any) => item.isActive);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secC_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.compareAtPrice + (target ? target?.compareAtPrice * target?.quantity : 0),
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // fb埋点
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            // window.open(card?.link_buy, '_blank');
            const addCarts: any = [
                {
                    price: card?.price,
                    compareAtPrice: card?.compareAtPrice,
                    inventoryQuantity: card?.inventoryQuantity,
                    inventoryPolicy: card?.inventoryPolicy,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    variantImg: card?.variantImg,
                    productTitle: card?.productTitle,
                    skuTitle: card?.skuTitle,
                    quantity: 1,
                },
            ];
            if (target?.quantity > 0) {
                addCarts.push({
                    price: target?.price,
                    compareAtPrice: target?.compareAtPrice,
                    inventoryQuantity: target?.inventoryQuantity,
                    inventoryPolicy: target?.inventoryPolicy,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    variantImg: target?.variantImg,
                    productTitle: target?.productTitle,
                    skuTitle: target?.skuTitle,
                    quantity: target?.quantity,
                });
            }
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, addCarts);
        }
    };

    const handleClick = (card: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (data: any, num: number, k: number, m: number) => {
        // setFocus(`${data?.variantId}_${k}_${m}`);
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcTotalEnergy(list?.energy, list?.quantity);
        card.saveMoney = calcTotalSave(list?.energy, list?.quantity);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child) {
            child = item?.children?.find((list: any) => list?.isActive);
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        item.statu = child?.quantity === 0 ? 0 : child?.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventoryQuantity ?? 1000;
        const { useState, useEffect } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);
        const isButtonsDisabled = Number(data?.inventoryQuantity || 0) <= 0 && data?.inventoryPolicy !== 'continue';
        const isPlusDisabled = number >= NUM_MAX || isButtonsDisabled;
        const tooltipKey = `${k}_${m}_${data?.variantId || data?.id || data?.title || ''}`;

        useEffect(() => {
            setNumber(data?.quantity ?? 1);
        }, [data?.quantity]);

        const reduceNumber = () => {
            if (isButtonsDisabled || number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (isButtonsDisabled || number >= NUM_MAX) return false;
            setOpenTooltipKey(null);
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            if (isButtonsDisabled) return;
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={`addSubtractor-reduce${number <= NUM_MIN || isButtonsDisabled ? ' disable' : ''}`} onClick={reduceNumber}>
                    -
                </div>
                <input className="addSubtractor-number" autoFocus={focus === `${data?.variantId}_${k}_${m}`} value={number} onChange={inputChange} />
                {isPlusDisabled ? (
                    <Tooltip
                        title={t('item_maximum_purchase_quantity')}
                        trigger="click"
                        visible={openTooltipKey === tooltipKey}
                        onVisibleChange={(visible) => {
                            setOpenTooltipKey((currentKey: any) => (visible ? tooltipKey : currentKey === tooltipKey ? null : currentKey));
                        }}
                    >
                        <div className="addSubtractor-add disable">+</div>
                    </Tooltip>
                ) : (
                    <div className="addSubtractor-add" onClick={addNumber}>
                        +
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (res.data && typeof res.data === 'object' && Object.keys(res.data).length === 0) {
                        return resolve({});
                    }
                    if (link_more) {
                        handleCalclate(item, item.children[0]);
                    }
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    if (res?.data?.handle) {
                        item.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject({ ...item });
                }
            } catch (e) {
                console.error(e);
                return reject({ ...item });
            }
        });
    };

    useEffect(() => {
        if (isNA && flag) {
            const tempSolarPanelsArr = JSON.parse(JSON.stringify(solarpanels));
            const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
            Promise.all(solarPromises)
                .then((res: any) => {
                    setSolarpanels(res.filter((item: any) => Object.keys(item || {}).length > 0));
                    setFlag2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [flag]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const promises = tempArr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res.filter((item: any) => Object.keys(item || {}).length > 0));
                setFlag(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (isNA && flag && flag2) {
            const tempArr = JSON.parse(JSON.stringify(cardLists));
            tempArr?.map((item: any, k: number) => {
                // item.children = JSON.parse(JSON.stringify());
                item.children = cloneDeep(item.children.map((_item: any) => solarpanels.find((s: any) => s.id === _item.id)).filter((item: any) => !!item));
                item.children.forEach((item: any) => (item.isActive = false));
                if (item.children[0]) {
                    item.children[0].isActive = true;
                }
                item?.children?.map((child: any) => {
                    if (!child) return;
                    child.cartTitle = `${child?.cartTitle}`;
                    child.recommand = getRecommand(item?.id, String(child?.id));
                    if (child?.inventoryQuantity < 0) {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventoryQuantity < child?.recommand[0]) {
                        child.quantity = child?.inventoryQuantity;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                    // child.quantity = child.recommand[0];
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setFlag3(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solarpanels, flag, flag2]);

    return (
        <div id="cost-saving-F" className={`cost-saving-F cost-saving-box inner ${css['cost-saving-F']}`}>
            <Swiper
                className="cards swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={gap}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <div className="card-top">
                            <div className="card-img">
                                <EFPicture src={card?.variantImg || card?.img} alt={card?.title} />
                            </div>
                            <p className="card-power">{card?.power}</p>
                            <p className="card-title">{card?.title}</p>
                            <ul className="card-descs">
                                {card?.descArr?.map(
                                    (desc: any, m: number) =>
                                        desc && (
                                            <li className="card-desc li" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ),
                                )}
                            </ul>
                            {locale === 'ca' && (
                                <p className={`card-calc-con card-calc-res`}>
                                    {t.rich('secF_card_save', {
                                        h: (text: string) => <span className="h">{text}</span>,
                                    })}
                                </p>
                            )}
                            {isNA && (
                                <>
                                    <p className="card-line"></p>
                                    {card?.children?.length > 0 && (
                                        <>
                                            <div className={`calc-info`}>
                                                {isNA && <p className={`card-calc`}>{t('common_card_calculator')}</p>}
                                                <p
                                                    className={`card-calc-res ${
                                                        isNA ? (card?.statu === 0 ? 'gray' : card?.statu === 1 ? 'recommand' : 'not-recommand') : 'recommand'
                                                    }`}
                                                >
                                                    {isNA
                                                        ? card?.statu === 0
                                                            ? t('common_card_0')
                                                            : card?.statu === 1
                                                            ? t.rich('common_card_calculator_res', {
                                                                  power: card?.energy,
                                                                  money: card?.saveMoney,
                                                                  h: (text: string) => (
                                                                      <span className="h">
                                                                          {t('common_card_unit')}
                                                                          {text}
                                                                      </span>
                                                                  ),
                                                              })
                                                            : t('common_card_no_recommand')
                                                        : t.rich('secF_card_save', {
                                                              h: (text: string) => <span className="h">{text}</span>,
                                                          })}
                                                </p>
                                            </div>

                                            <div className="card-output">
                                                <p className="output-text">{t('secD_card_output')}</p>
                                                <ul className="output-lists">
                                                    {card?.children?.map((list: any, m: number) => (
                                                        <li
                                                            className={`output-list ${list?.isActive ? 'active' : ''}`}
                                                            key={`${k}_${m}`}
                                                            onClick={() => handleClick(card, k, m)}
                                                        >
                                                            {list?.title}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="card-quantity card-output">
                                                <p className="output-text">{t('secD_card_quantity')}</p>
                                                <ul className="quantity-lists">
                                                    {card?.children?.map((list: any, m: number) => (
                                                        <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                                            <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {card?.text?.desc && (
                                <div className="card-text-box">
                                    <p className="text-title">{card?.text?.title}</p>
                                    <div className={`text-desc-box ${opens?.includes(k) ? 'open' : 'close'}`}>
                                        <p className="text-desc">
                                            {t.rich(card?.text?.desc, {
                                                c: (tx: string) => <span className="c">{tx}</span>,
                                            })}
                                        </p>
                                        <span
                                            className="arrow"
                                            onClick={() => setOpens(opens?.includes(k) ? opens?.filter((o: number) => o !== k) : [...opens, k])}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <path
                                                    d="M2.42822 7.82052L6.33468 3.91406L10.2411 7.82052"
                                                    stroke="white"
                                                    strokeWidth="1.02544"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="card-bot">
                            <div className="card-btns">
                                {card?.link_buy && (
                                    <>
                                        {Number(card?.inventoryQuantity) <= 0 ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p
                                                className={`btn-buy card-btn`}
                                                onClick={() => {
                                                    if (locale === 'za') {
                                                        window.open(card.buy_now, '_blank');
                                                        return;
                                                    }
                                                    flag && flag2 && flag3 && handleBuy(card);
                                                }}
                                            >
                                                {locale === 'za' ? t('common_card_buy_now') : t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={`${card?.link_more}${
                                            String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secF_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
